import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { register } from '../utils/auth';

import './auth.css';

export default function Register() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  function onSubmit(e) {
    e.preventDefault();
    if (!username.trim() || !password) {
      setError('请填写用户名和密码');
      return;
    }
    const res = register({ username: username.trim(), password });
    if (!res.ok) {
      setError(res.error);
      return;
    }
    navigate('/');
  }

  return (
    <div className="auth-wrap">
      <h1>注册</h1>
      <form className="editor" onSubmit={onSubmit}>
        <input placeholder="用户名" value={username} onChange={e => setUsername(e.target.value)} />
        <input placeholder="密码" type="password" value={password} onChange={e => setPassword(e.target.value)} />
        {error && <div className="error">{error}</div>}
        <div className="auth-actions">
          <div />
          <div className="editor-actions">
            <button className="btn" type="submit">注册</button>
          </div>
        </div>
      </form>
      <div style={{ marginTop: 12, textAlign: 'center' }}>
        已有账号？ <Link to="/login">登录</Link>
      </div>
    </div>
  );
}
